import { meta } from './meta';

export const isStandalone = meta.provider !== 'all';

export const isInstagram = meta.provider === 'instagram';

export const isFacebook = meta.provider === 'facebook';
